module.exports = __webpack_public_path__ + "static/img/5.9c0f9d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/5.jpg
// module id = sEFU
// module chunks = 1